/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StaffMemberRouteLinkItem from './StaffMemberRouteLinkItem';
import CalendarIcon from 'icons/CalendarIcon';

const messages = defineMessages({
  title: {id: 'navigation.calendar'},
});

const CalendarItem = () => (
  <StaffMemberRouteLinkItem
    iconBefore={CalendarIcon}
    route="midas/staff-member/calendar"
    title={messages.title}
  />
);

export default CalendarItem;
